export const DEBOUNCE_TIME_MS = 500;
export const ADMIN_API_URL_SUBPATH = '/admin';
